import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Settings() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [busy, setBusy] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    if (np.length < 8) return toast.error("Password must be at least 8 chars");
    setBusy(true);
    try {
      await api.post("/admin/auth/change-password", { current_password: cur, new_password: np });
      toast.success("Password updated");
      setCur(""); setNp("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="p-8 lg:p-10 max-w-3xl">
      <p className="tech-label">Account</p>
      <h1 className="font-display text-4xl font-black tracking-tighter">Settings.</h1>

      <div className="mt-8 border border-zinc-200 rounded-lg bg-white p-6">
        <p className="tech-label">Profile</p>
        <p className="mt-2 text-sm text-zinc-500">Email: <span className="text-zinc-900 font-semibold">{user?.email}</span></p>
        <p className="text-sm text-zinc-500">Role: <span className="text-zinc-900 font-semibold">{user?.role}</span></p>
      </div>

      <form onSubmit={change} className="mt-6 border border-zinc-200 rounded-lg bg-white p-6" data-testid="settings-change-password">
        <p className="tech-label mb-4">Change Password</p>
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <Label className="tech-label">Current Password</Label>
            <Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required className="h-11 mt-2 bg-zinc-50" data-testid="settings-cur"/>
          </div>
          <div>
            <Label className="tech-label">New Password (min 8)</Label>
            <Input type="password" value={np} onChange={(e) => setNp(e.target.value)} required minLength={8} className="h-11 mt-2 bg-zinc-50" data-testid="settings-new"/>
          </div>
        </div>
        <Button type="submit" disabled={busy} className="mt-4 bg-zinc-900 text-white h-11" data-testid="settings-save">{busy ? "Saving…" : "Update Password"}</Button>
      </form>
    </div>
  );
}
